export enum TranskodeVideoCodec {
  ProRes = "ProRes",
  Imx30 = "Imx30",
  Imx50 = "Imx50",
  XdcamHD50 = "XdcamHD50",
  AS10 = "AS10",
  AS11 = "AS11",
  Mpeg2 = "Mpeg2",
  H264 = "H264",
  AVCIntra = "AVCIntra",
  ProResLT = "ProResLT",
  Uncompressed = "Uncompressed",
  ProResXQ = "ProResXQ",
  XavcSony = "XavcSony",
  Mpeg1 = "Mpeg1",
  DNxHD = "DNxHD",
  DNxHR = "DNxHR",
  VC1 = "VC1",
  J2K = "J2K",
  HEVC = "HEVC",
  DV = "DV",
  DVCPro = "DVCPro",
  YUV = "YUV",
}
